import React from 'react';
import { Box, Typography } from '@mui/material';
import ApiParametersTable from '../ApiParametersTable';
import ApiEndpointDisplay from '../ApiEndpointDisplay';
import ApiResponseExamples from '../ApiResponseExamples';
import ApiRequestExamples from '../ApiRequestExamples';

const SdVideoPlaybackApi: React.FC = () => {
    const parameters = [
        { type: 'HEAD', name: 'Authorization', dataType: 'string', required: true },
        { type: 'POST', name: 'vehicleId', dataType: 'string', required: true },
        { type: 'POST', name: 'cameraId', dataType: 'string', required: true },
        { type: 'POST', name: 'startDateTime', dataType: 'string', required: true },
        { type: 'POST', name: 'endDateTime', dataType: 'string', required: true },
    ];

    return (
        <Box className="flex flex-col border-b border-gray-200">
            <Typography variant="h6" marginBottom={1} fontWeight={600} fontSize={16} id="sd-video-playback">
                GET SD VIDEO PLAYBACK URL ON DEMAND
            </Typography>
            
            <Typography variant='body2' marginBottom={2} fontSize={14} fontWeight={400}>
                To get the SD video playback URL for a specific vehicle, you must send a POST request. This request requires an Authorization token in the headers and a request body containing the details of the vehicle for which you want to retrieve the playback URL.
            </Typography>

            <Typography variant='body2' marginBottom={1} fontSize={18} fontWeight={600}>Request</Typography>
            <ApiEndpointDisplay 
                method="POST" 
                url="https://backend.novusomnifleet.com/api/client/v1/play-sd-card" 
            />

            <ApiParametersTable parameters={parameters} />

            <ApiRequestExamples
                examples={[
                    {
                    type: "headers",
                    headers: [
                        {
                        key: "Authorization",
                        value:
                            "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJJQ1NBIiwidXNlcklkIjoiNjdkOTBkMDdlNGNhZTU3MDEwMzQyYzA4Iiwicm9sZXMiOiJST0xFX0ZMRUVUX01BTkFHRVIiLCJpYXQiOjE3NTQzNzIyNjksImV4cCI6MTc1NDQwODI2OX0.NItAkAwXNGKxoAsUTZSwB0lzFPHgW3I4ZwpLEY4c-Lo"
                        }
                    ],
                    label: "Request Headers"
                    },
                   {
                    type: "body",
                    contentType: "json",
                    value: `{
 "vehicleId": "9090",
 "cameraId": "01",
 "startDateTime": "2025-06-05:13:04:48",
 "endDateTime": "2025-06-25:16:40:23"
}`,
                    label: "Request Body"
                    }
                ]}
            />


            <ApiResponseExamples 
                examples={[
                    {
                        status: '200',
                        description: 'Success',
                        response: `{
                                    "data": {
                                      "cameraId": "2",
                                      "playBackurl": "https://video.novusomnifleet.com:443/live/8633860743323233_1753930510_2.m3u8",
                                      "cameraName": "DSM"
                                    },
                                    "message": "Sd Card File Playback Url fetched Successfully",
                                    "status": 200
                                  }`
                    },
                    {
                        status: '400',
                        description: 'Missing vehicleId',
                        response: `{
                                      "success": false,
                                      "message": "Invalid request body",
                                      "errors": [
                                        {
                                          "code": "missing_field",
                                          "field": "vehicleId",
                                          "detail": "VehicleId is required"
                                        }
                                      ]
                                    }`
                    },
                    {
                        status: '400',
                        description: 'Missing startDateTime',
                        response: `{
                                      "success": false,
                                      "message": "Invalid request body",
                                      "errors": [
                                        {
                                          "code": "missing_field",
                                          "field": "startDateTime",
                                          "detail": "startDateTime is required"
                                        }
                                      ]
                                    }`
                    },
                    {
                        status: '401',
                        description: 'Unauthorized',
                        response: `{
                                      "success": false,
                                      "message": "Invalid username or password"
                                    }`
                    },
                    {
                        status: '500',
                        description: 'Server Error',
                        response: `{
                                      "success": false,
                                      "message": "An internal server error occurred"
                                    }`
                    }
                ]}
            />
          </Box>
    );
};

export default SdVideoPlaybackApi;
